<app-header></app-header>
<div class="report-body">
  <app-menu></app-menu>
  <router-outlet></router-outlet>
  <app-support *ngIf="supportActive"></app-support>
  <app-settings *ngIf="settingsActive"></app-settings>
</div>
